module.exports = __webpack_public_path__ + "img/spartan-roof-replacement-waterproofing-06-square.a200e4b6.jpg";